var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptyLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 49,
  height: 49,
  viewBox: "0 0 49 49",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "normal"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "icon",
  d: "M35.06 18.37L26.54 9.85L26.54 18.37L35.06 18.37ZM36.75 40.83L36.75 22.45L23.47 22.45C22.91 22.45 22.45 22 22.45 21.43L22.45 8.16L12.25 8.16L12.25 40.83L36.75 40.83ZM10.2 44.91C9.08 44.91 8.16 44 8.16 42.87L8.16 6.12C8.16 4.99 9.08 4.08 10.2 4.08L26.12 4.08C26.4 4.08 26.65 4.19 26.85 4.38L40.53 18.06C40.72 18.25 40.83 18.51 40.83 18.78L40.83 42.87C40.83 44 39.91 44.91 38.79 44.91L10.2 44.91Z",
  fill: "#BBE4FC",
  fillOpacity: 1,
  fillRule: "evenodd"
}))));
export default SvgEmptyLink;